
<ng5-slider [(value)]="minValue" [(highValue)]="maxValue" [options]="options" (userChange)='onUserChange($event)'></ng5-slider>